"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FuelPricesContractConnector = void 0;
const autogenerated_1 = require("../autogenerated");
const FuelContractConnector_1 = require("../FuelContractConnector");
const FuelPricesContractAdapter_1 = require("./FuelPricesContractAdapter");
class FuelPricesContractConnector extends FuelContractConnector_1.FuelContractConnector {
    constructor(wallet, contractId) {
        super(wallet);
        this.contractId = contractId;
    }
    async getContract() {
        return autogenerated_1.PricesAbi__factory.connect(this.contractId, this.wallet);
    }
    async getAdapter() {
        return new FuelPricesContractAdapter_1.FuelPricesContractAdapter(await this.getContract(), this.getGasLimit());
    }
}
exports.FuelPricesContractConnector = FuelPricesContractConnector;
//# sourceMappingURL=FuelPricesContractConnector.js.map